<template>
    <div>
        <div class="warp padtb20">
            <el-row class="main">
                <el-col :span="3">
                    <div class="logosmall">
                        <img src="/static/img/logo@2x.png" alt />
                        <!-- <img src="" alt=""> -->
                    </div>
                </el-col>
                <el-col :span="16" :offset="1">
                    <el-row>
                        <el-col :span="4" v-for="(item, index) in list" :key="index" class="entrustlist" @click.native="gonext(item.url, item.id)">
                            <!-- <router-link :to="item.url+'?type='+item.id"> -->
                            <span :class="[item.id==3?'colred':'col333',' title47bHouer font20 weightbold']">{{
                item.name
              }}</span>
                            <!-- </router-link> -->
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="2"> </el-col>
            </el-row>
        </div>

        <div class="entrustinp">
            <el-row class="main">
                <div class="textcenter col000 font30 weightbold">委托购买好房</div>
                <div class="textcenter col000 font24">海量真实房源 就在城市好房</div>
                <div>
                    <el-form :model="dataForm" ref="dataForm" label-width="100px" class="fromStyle" style="weight: 200px" inline v-loading="loading" :rules="rules">
                        <el-row class="bor1" justify="center">
                            <el-form-item label="写字楼名:" class="FormitemW100 " prop="dictName">
                                <el-col :span="20">
                                    <el-input type="text" v-model="dataForm.dictName" placeholder="请输入写字楼楼盘名"></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row class="bor1" justify="center">
                            <el-form-item label=" 区域:" class="FormitemW100 " prop="districtCode">
                                <el-col :span="10">
                                    <el-select v-model="dataForm.districtCode" placeholder="请选择" clearable @change="CityRegionChange" class="FormSelect">
                                        <el-option v-for="item in this.$store.state.cityregion" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-col>
                                <el-col :span="10">
                                    <el-select v-model="dataForm.business" placeholder="请选择" :disabled="dataForm.districtCode == ''" class="FormSelect" clearable>
                                        <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                    </el-select>
                                </el-col>
                            </el-form-item>

                        </el-row>
                        <el-row class="bor1" justify="center">
                            <el-form-item label="期望售价:" class="FormitemW100">
                                <el-col :span="20">
                                    <el-input type="text" v-model="dataForm.priess" placeholder="请输入你期望出售的价格">><template slot="append">万元</template></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row class="bor1" justify="center">
                            <el-form-item label="称呼:" class="FormitemW100">
                                <el-col :span="20">
                                    <el-input type="text" v-model="dataForm.customerName" placeholder="我们应该如何称呼你">></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row class="bor1" justify="center">
                            <el-form-item label="手机号码:" class="FormitemW100" prop="mobile">
                                <el-col :span="20">
                                    <el-input type="text" v-model="dataForm.mobile" placeholder="你的联系方式，方便我们及时与你联系">></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row class="bor1" justify="center">
                            <el-form-item label="备注:" class="FormitemW100">
                                <el-col :span="20">
                                    <el-input type="textarea" :rows="2" v-model="dataForm.remake" placeholder="有其他需要补充的请额外补充">></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <!-- <el-row class="bor1">
            <el-col :span="16"><el-input type="text"  /></el-col>
            <el-col :span="6" class="textcenter line40">获取验证码</el-col>
          </el-row> -->
                        <el-row class="bor1">
                            <el-col :span="4" class="textcenter line40"> </el-col>
                            <el-col :span="10">
                                <el-button type="danger" @click="dataFormSubmitHandle('dataForm')">提交</el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dataForm: {
                dictName: "",
                zd: "",
                dy: "",
                fj: "",
                priess: "",
                phone: "",
                remake: ""
            },
            loading: false,
            list: [

                { name: "委托租房", url: "entrustzf", id: "2" },
                { name: "委托买房", url: "entrustmf", id: "3" },
            ],
            rules: {
                dictName: [
                    { required: true, message: "请输入写字楼名称", trigger: "blur" },
                ],
                mobile: [
                    { required: true, message: "请输入您的联系方式", trigger: "blur" },
                ],
            },
        };
    },
    created() { },
    mounted() {
        this.$emit('getMenuId', 6);
    },
    methods: {
        // 表单提交
        dataFormSubmitHandle(dataForm) {
            this.$refs[dataForm].validate((valid) => {
                if (valid) {
                    let _this = this;
                    this.$post(this.$api.entrust.save, this.dataForm)
                        .then(({ data: res }) => {
                            if (res.code !== 0) {
                                console.log(res.msg);
                            }
                            this.$message.success("委托成功！");
                        })
                        .catch(() => {
                            this.$message({
                                type: "info",
                                message: "委托失败！",
                            });
                        });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        gonext(path, id) {
            console.log("id", path, id);
            this.select = id;
            this.$router.push({ name: path, params: { type: id } });
        },
    },
};
</script>

<style   lang="scss">
.bgwrap {
    width: 100%;
    height: 77.0625rem;
    margin-top: -2.75rem;
    background: url(../../../static/img/wt.png) no-repeat;
    background-size: 100%;
    padding-top: 10%;
}
.entrustinp {
    width: 100%;
    background: #fff;
    padding: 20px 25px;
    margin: auto;
}
.bor1 {
    padding: 10px 3px;
    /* border-bottom: 1px solid #E6E6E6; */
    margin: 10px 0px;
    font-size: 14px;
}
.subbtn {
    width: 100%;
    height: 3rem;
    background: url(../../../static/img/btnbg.png) no-repeat;
    background-size: 100% 100%;
    text-align: center;
    font-size: 1rem;
    color: #fff;
    line-height: 3rem;
    margin-top: 1.25rem;
}
.warp {
    width: 100%;
    border-bottom: 0.0625rem solid #da251d;
}
.main {
    width: 75rem;
    margin: auto;
    color: #666;
    font-size: 14px;
}
.logosmall {
    width: 9.25rem;
    height: 2.5rem;
}
.logosmall img {
    width: 100%;
    height: 100%;
}
.entrustlist {
    margin-top: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/entrust/entrustmf.vue